import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../common/components/form/form.module'

export default function EmailAccountBasicInfoComponent ({handleInnerFormChange, selectEmailAccounts}: any) {
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
         
          <InputContainer

                  label="Email"
                  name="Email"
                  onValueChange={(event: any) => {
                    handleInnerFormChange(
                      event.target.value,
                       'Email',

                         )
                       }}
                   type="text"
                   value={selectEmailAccounts?.Email}
                />
                <InputContainer

                label="DisplayName"
                name="DisplayName"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                     'DisplayName',
                
                       )
                     }}
                 type="text"
                 value={selectEmailAccounts?.DisplayName}
                />
                <InputContainer

                label="Host"
                name="Host"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                     'Host',
                
                       )
                     }}
                 type="text"
                 value={selectEmailAccounts?.Host}
                />
            <InputContainer
              label="Port"
              name="Port"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Port',

                )
              }}
              type="number"
              value={selectEmailAccounts?.Port}
          />
           <InputContainer
              label="Username"
              name="Username"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Username',

                )
              }}
              type="text"
              value={selectEmailAccounts?.Username}
          />
           <InputContainer
              label="Password"
              name="Password"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Password',

                )
              }}
              type="Password"
              value={selectEmailAccounts?.Password}
          />
           <InputContainer

            label="EnableSsl"           
name="EnableSsl"
onValueChange={(event: any) => {
handleInnerFormChange(
 event,
'EnableSsl',

)
}}
type="checkbox"
            value={selectEmailAccounts?.EnableSsl}
            />
            <InputContainer

            label="UseDefaultCredentials"
            name="UseDefaultCredentials"
            onValueChange={(event: any) => {
            handleInnerFormChange(
             event,
            'UseDefaultCredentials',

            )
            }}
            type="checkbox"
            value={selectEmailAccounts?.UseDefaultCredentials}
            />
     </div>
  }
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}